<template>
    <div v-if="blok">
        <uiPage :blok="blok" :airport="blok.AirportEntity" :products="products" :airport-stats="airportStats" />
        <!--modals-->
        <Component
            :is="globalStore.signInModal.component"
            v-if="globalStore && globalStore.signInModal"
            :global="globalStore.global.content"
            :blok="globalStore.signInModal"
        />
        <Component
            :is="globalStore.resetPasswordModal.component"
            v-if="globalStore && globalStore.resetPasswordModal"
            :global="globalStore.global.content"
            :blok="globalStore.resetPasswordModal"
        />
        <Component
            :is="globalStore.signUpModal.component"
            v-if="globalStore && globalStore.signUpModal"
            :global="globalStore.global.content"
            :blok="globalStore.signUpModal"
        />
    </div>
</template>

<script setup lang="ts">
import type { IAirportProducts, IAirportStats } from '@nuxt-monorepo/ui/types';
import { useGlobalStore } from '@nuxt-monorepo/base/app/store/global';

const config = useRuntimeConfig();

const { blok, products, airportStats } = defineProps<{
    blok: any;
    products: IAirportProducts;
    airportStats?: IAirportStats | null | undefined;
}>();
const { t } = useI18n();
const siteInfo = computed(() => {
    return {
        site: 'PSF',
        parkingBtnText: t('viewDeal'),
    };
});
provide('baseInfo', siteInfo);

const globalStore: any = useGlobalStore();

// TODO: Maybe find a better solution for this later
// Set custom variable so searchbox would be updated with default destination
blok.body.find((e: any) => {
    return e.Searchbox?.[0];
}).Searchbox[0].defaultDestination = {
    airport_code: blok.AirportEntity.content.code,
    fullname: blok.AirportEntity.content.code
        ? `${blok.AirportEntity.content.city} (${blok.AirportEntity.content.code})`
        : '',
    location: { latitude: '', longitude: '' },
    type: '',
};

const initialDestination = await useUpdateAirportByCode(
    config.public,
    normalizeAirportSlug(blok.AirportEntity.slug),
    false
);
provide('initialDestination', initialDestination);

function normalizeAirportSlug(slug: string): string {
    // Storyblok provides the airport slug for port of seattle as 'sez', but the fetchAlgolia API expects 'zea'.
    if (slug === 'sez') return 'zea';
    return slug;
}

await $getSession();

// Call for Session
$getSession();
</script>
